import React from 'react';
import Header from './Header';
import Hero from './Hero';
import WhyChooseUs from './WhyChooseUs';
import Instructors from './Instructors';
import VehicleGallery from './VehicleGallery';
import Courses from './Courses';
import WhatYouLearn from './WhatYouLearn';
import Testimonials from './Testimonials';
import FAQ from './FAQ';
import Contact from './Contact';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <Header />
      <Hero />
      <WhyChooseUs />
      <Instructors />
      <VehicleGallery />
      <Courses />
      <WhatYouLearn />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
};

export default LandingPage;